/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : GENERAL : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    general: {
        
    }
});